import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { LanguageSwitch } from './LanguageSwitch';

export function Header() {
  const { t } = useLanguage();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => setIsOpen(false), [location.pathname]);

  return (
    <header className="site-header">
      <a className="skip-link" href={`${location.pathname}#main-content`}>Skip to content</a>
      <div className="header-inner shell">
        <Link className="brand" to="/" aria-label="Queen English Academy">
          <img src="/brand/queen-logo.png" alt="" width="877" height="877" />
          <span>
            <strong>QUEEN</strong>
            <small>English Academy</small>
          </span>
        </Link>

        <button
          className="menu-toggle"
          type="button"
          aria-label="Menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((value) => !value)}
        >
          <span />
          <span />
        </button>

        <div className={`header-panel${isOpen ? ' is-open' : ''}`}>
          <nav className="main-nav" aria-label="Primary navigation">
            <a href="/#about">{t.nav.about}</a>
            <a href="/#approach">{t.nav.approach}</a>
            <a href="/#lessons">{t.nav.lessons}</a>
            <a href="/#teacher">{t.nav.teacher}</a>
            <a href="/#contact">{t.nav.contact}</a>
          </nav>
          <LanguageSwitch />
          <Link className="button button-small button-gold" to="/test">{t.nav.test}</Link>
        </div>
      </div>
    </header>
  );
}
